@if (error) {
<div class="empty-state">
  <mat-icon class="empty-state-icon">error_outline</mat-icon>
  <h2>Kunne ikke indlæse lokationer</h2>
  <p>{{ error }}</p>
</div>
} @else if (loaded && locations.length === 0) {
<div class="empty-state">
  <mat-icon class="empty-state-icon">location_off</mat-icon>
  <h2>{{ emptyStateTitle }}</h2>
  <p>{{ emptyStateMessage }}</p>
</div>
} @else {
<div class="locations-grid">
  @for (location of locations; track location) {
  <mat-card class="location-card">
    <mat-card-header>
      <div class="location-card-heading">
        <mat-card-title>{{ location.locations_name }}</mat-card-title>
        @if (getLocationAssignment(location); as assignment) {
        <span
          class="assignment-label"
          [class.assignment-label--primary]="assignment.type === 'primaer'"
          [class.assignment-label--secondary]="assignment.type === 'sekundaer'"
          >{{ assignment.label }}</span
        >
        }
      </div>
      <mat-card-subtitle>{{ getLocationType(location) }}</mat-card-subtitle>
    </mat-card-header>
    <button
      type="button"
      class="location-card-image-button"
      (click)="goToLocation(location)"
      [attr.aria-label]="'Gå til ' + location.locations_name"
    >
      <app-duna-profile-image
        mat-card-image
        class="location-card-image"
        [obfuscatedName]="getLocationProfileImage(location)"
        [fallbackInitials]="getLocationInitials(location)"
        [placeholderSrc]="'assets/lokation_placeholder.jpg'"
        [size]="200"
        [canEdit]="false"
        [enablePreview]="false"
        [variant]="'card'"
      ></app-duna-profile-image>
    </button>
    <mat-card-content>
      <p>{{ getLocationAddress(location) }}</p>
    </mat-card-content>
    <mat-card-actions>
      <button
        mat-raised-button
        color="primary"
        (click)="goToLocation(location)"
      >
        Gå til lokation
      </button>
    </mat-card-actions>
  </mat-card>
  }
</div>
}
